export const isSSR = () => typeof window === 'undefined';



// WEBPACK FOOTER //
// ./app/services/is-ssr.js